import Debounce from './debounce';
import Throttle from './throttle';


/**
 * Esta diretiva serve para evitar disparos desnecessarios
 * @Debounce - Enquanto for disparado não chama o método,
 *      apenas após um segundo sem disparos que o método é chamado.
 *      este método também interrompe a pausa caso o usuario aperte enter, chamando
 *      imediatamente o método.
 *  Exemplo de uso: <input v-s-debounce="func" />
 * @Throttle - Este serve para clicks, no primeiro click o método é disparado
 *      mas evitamos disparos seguintes durante um segundo.
 *  Exemplo de uso: <input v-s-debounce:click="func" />
 *
 */

export default {
  name: 's-trigger',
  install(Vue) {
    Vue.directive('s-trigger', {
      bind(el, { value, arg }) {
        const fnDebounce = Debounce((target) => {
          value(target.value);
        });
        const fnThrottle = Throttle((target) => {
          value(target.value);
        });
        const element = el;
        if (arg === 'click') {
          element.addEventListener(arg, ({ target }) => fnThrottle(target, arg));
          return;
        }
        element.addEventListener('keyup', ({ code, target }) => {
          if (code === 'Enter') {
            fnDebounce.cancel();
            value(target.value);
          }
          if (code !== 'Enter') {
            fnDebounce(target);
          }
        });
      },
    });
  },
};
